import { Component, TemplateRef, ChangeDetectionStrategy, OnInit, Output, EventEmitter, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ITechnique } from '../../models/solution';
import { UxaButtonModule } from '@ux-aspects-universal/angular/button';
import { UxaIconModule, provideIcons } from '@ux-aspects-universal/angular/icon';
import { close } from '@ux-aspects-universal/angular/icon/jato';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-mitre-modal-content',
  templateUrl: './modal-content.component.html',
  styleUrls: ['./modal-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    UxaButtonModule,
    UxaIconModule,
    CommonModule
  ],
  viewProviders: [
    provideIcons({ close })
  ],
  standalone: true
})
export class ModalContentComponent {

  @Input() modalTitle = '';
  @Input() titleTemplateRef: TemplateRef<void>;
  @Input() contentTemplateRef: TemplateRef<void>;
  @Input() technique: ITechnique;
  @Input() currentTactic: string;

  @Output() hideModal = new EventEmitter<void>

  hide() {
    this.hideModal.emit();
  }
}
